<template>
  <div>
    <form-accordion :title="$t('common.routing.general_config')" :isTitleUpperCase="false">
      <b-row>

        <b-col sm="12" class="form-group">
          <label for="enable-tcp-keep-alive">
            {{ $t('common.routing.active') }}
<!--            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.enable_tcp_keep_alive_info')"></i>-->
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="enableActive = !enableActive" :checked="enableActive" v-bind:value="enableActive">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="ConfigName" isMandatory disabled
            :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="Region" isMandatory :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.region')" :placeholderValue="$t('common.routing.region')" :tooltipLabel="$t('common.routing.region_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="URI" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.uri')" :placeholderValue="$t('common.routing.uri')" :tooltipLabel="$t('common.routing.uri_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="Port" :disabled="readonly"
            :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')" inputType="number" :tooltipLabel="$t('common.routing.port_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="BucketName" :disabled="readonly"
            :inputLabel="$t('common.routing.bucket_name')" :placeholderValue="$t('common.routing.bucket_name')" :tooltipLabel="$t('common.routing.bucket_name_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="Prefix != ''">
          <form-write-group-label-input v-model="Prefix" :disabled="readonly" :maxLength="512"
            :inputLabel="msgType == '2' && entitiesType == '2' && inputValue.Role == '1' ? $t('common.routing.end_treatment_prefix') : msgType == '2' && entitiesType == '2' && inputValue.Role == '0' ? $t('common.routing.prefix_archiving') : $t('common.routing.prefix')"
            :placeholderValue="msgType == '2' && entitiesType == '2' && inputValue.Role == '1' ? $t('common.routing.end_treatment_prefix') : msgType == '2' && entitiesType == '2' && inputValue.Role == '0' ? $t('common.routing.prefix_archiving') : $t('common.routing.prefix')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="PrefixArchiving != '' || (entitiesType == '2' && msgType == '2' && inputValue.Role == '1')">
          <form-write-group-label-input v-model="PrefixArchiving" :disabled="readonly" :maxLength="512"
            :inputLabel="entitiesType == '2' && msgType == '2' && inputValue.Role == '1' ? $t('common.routing.prefix_case_error') : $t('common.routing.prefix_archiving')"
            :placeholderValue="entitiesType == '2' && msgType == '2' && inputValue.Role == '1' ? $t('common.routing.prefix_case_error') : $t('common.routing.prefix_archiving')">
          </form-write-group-label-input>
        </b-col>
        <!-- <b-col sm="6" class="form-group" >
          <form-write-group-label-input v-model="AccessKey" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.access_key')" :placeholderValue="$t('common.routing.access_key')" :tooltipLabel="$t('common.routing.access_key_info')">
          </form-write-group-label-input>
        </b-col> -->
        <!-- <b-col sm="6" class="form-group">
          <label>{{$t('common.routing.secret_key')}}
            <span style="color: red"> *</span>
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.secret_key_info')"></i>
          </label>
          <div class="d-flex">
            <input v-model="SecretKey"
              class="form-control inputAccordionForm h-30px"
              :type="secretKeyPasswordType"
              :placeholder="$t('common.routing.secret_key')"
              :disabled="readonly">
              <div class="icon icon-password mt-2 pt-1 icon-field"
                :class="[isSecretKeyPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                @click="switchSecretKeyPasswordType">
              </div>
            </input>
          </div>
        </b-col> -->
      </b-row>
    </form-accordion>

    <hr class="mx-auto" />
    <form-accordion :title="$t('common.routing.connect_option')" :isTitleUpperCase="false" :open="false">
      <b-row>
        <b-col sm="6" class="form-group">
          <label for="scheme">
            {{ $t('common.routing.scheme') }}
            <span class="color-red"> * </span>
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.scheme_info')"></i>
          </label>
          <select class="form-control" v-model="Scheme" :disabled="readonly" id="scheme">
            <option value="HTTPS" selected> {{ $t('common.routing.https') }} </option>
            <option value="HTTP"> {{ $t('common.routing.http') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="use-dual-stack">
            {{ $t('common.routing.use_dual_stack') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.use_dual_stack_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="useDualStack = !useDualStack" :checked="useDualStack" v-bind:value="useDualStack">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="maxConnections" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.max_connections')" :placeholderValue="$t('common.routing.max_connections')" inputType="number" :tooltipLabel="$t('common.routing.max_connections_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="RequestTimeoutMs" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.request_timeout_ms')" :placeholderValue="$t('common.routing.request_timeout_ms')" inputType="number" :tooltipLabel="$t('common.routing.request_timeout_ms_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="ConnectTimeoutMs" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.connect_timeout_ms')" :placeholderValue="$t('common.routing.connect_timeout_ms')" inputType="number" :tooltipLabel="$t('common.routing.connect_timeout_ms_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="enable-tcp-keep-alive">
            {{ $t('common.routing.enable_tcp_keep_alive') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.enable_tcp_keep_alive_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="enableTcpKeepAlive = !enableTcpKeepAlive" :checked="enableTcpKeepAlive" v-bind:value="enableTcpKeepAlive">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="tcpKeepAliveInvervalMs" :isMandatory="enableTcpKeepAlive === true" :disabled="readonly"
            :inputLabel="$t('common.routing.tcp_keep_alive_inverval_ms')" :placeholderValue="$t('common.routing.tcp_keep_alive_inverval_ms')" inputType="number" :tooltipLabel="$t('common.routing.tcp_keep_alive_inverval_ms_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="lowSpeedLimit" isMandatory :disabled="readonly"
            :inputLabel="$t('common.routing.low_speed_limit')" :placeholderValue="$t('common.routing.low_speed_limit')" inputType="number" :tooltipLabel="$t('common.routing.low_speed_limit_info')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </form-accordion>

    <hr class="mx-auto" />
    <form-accordion :title="$t('common.routing.proxy_config')" :isTitleUpperCase="false" :open="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="proxy-active">
            {{ $t('common.routing.proxy_active') }}
            <!-- <span class="color-red"> * </span> -->
          </label>
          <select class="form-control" v-model="proxyActive" :disabled="readonly" id="proxy-active">
            <option value="1"> {{ $t('common.routing.yes') }} </option>
            <option value="0" selected> {{ $t('common.routing.no') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group"></b-col>
        <b-col v-if="proxyActive == '1'" sm="6" class="form-group">
          <label for="proxy-cheme">
            {{ $t('common.routing.proxy_scheme') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.proxy_scheme_info')"></i>
          </label>
          <select class="form-control" v-model="proxyScheme" :disabled="readonly" id="proxy-scheme">
            <option value="HTTPS" selected> {{ $t('common.routing.https') }} </option>
            <option value="HTTP"> {{ $t('common.routing.http') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyHost" :disabled="readonly" :maxLength="10"
            :inputLabel="$t('common.routing.proxy_host')" :placeholderValue="$t('common.routing.proxy_host')" :tooltipLabel="$t('common.routing.proxy_host_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyPort" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_port')" :placeholderValue="$t('common.routing.proxy_port')" inputType="number" :tooltipLabel="$t('common.routing.proxy_port_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="proxyActive == '1'">
          <form-write-group-label-input v-model="proxyLogin" :disabled="readonly" :maxLength="512"
            :inputLabel="$t('common.routing.proxy_login')" :placeholderValue="$t('common.routing.proxy_login')" :tooltipLabel="$t('common.routing.proxy_login_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col v-if="proxyActive == '1'" sm="6" class="form-group">
          <label>
            {{$t('common.routing.proxy_pwd')}}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.proxy_pwd_info')"></i>
          </label>
          <div class="d-flex">
            <input v-model="proxyPwd"
              class="form-control inputAccordionForm h-30px"
              :type="proxyPasswordType"
              :placeholder="$t('common.routing.proxy_pwd')"
              :disabled="readonly">
              <div class="icon icon-password mt-2 pt-1 icon-field"
                :class="[isProxyPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                @click="switchProxyPasswordType">
              </div>
            </input>
          </div>
        </b-col>
      </b-row>
    </form-accordion>

    <!-- <hr class="mx-auto" />
    <form-accordion :title="$t('common.routing.ssl_config')" :isTitleUpperCase="false" :open="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="verify-ssl">
            {{ $t('common.routing.verify_ssl') }}
            <span class="color-red"> * </span>
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.verify_ssl_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="VerifySSL = !VerifySSL" :checked="VerifySSL" v-bind:value="VerifySSL">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="caPath" :disabled="readonly"
            :inputLabel="$t('common.routing.ca_path')" :placeholderValue="$t('common.routing.ca_path')" :tooltipLabel="$t('common.routing.ca_path_info')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="caFile" :disabled="readonly"
            :inputLabel="$t('common.routing.ca_file')" :placeholderValue="$t('common.routing.ca_file')" :tooltipLabel="$t('common.routing.ca_file_info')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </form-accordion> -->

    <hr class="mx-auto" />
    <form-accordion :title="$t('common.routing.query_options')" :isTitleUpperCase="false" :open="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="follow-redirects">
            {{ $t('common.routing.follow_redirects') }}
            <span class="color-red"> * </span>
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.follow_redirects_info')"></i>
          </label>
          <select class="form-control" v-model="FollowRedirects" :disabled="readonly" id="follow-redirects">
            <option value="Always"> {{ $t('common.routing.always') }} </option>
            <option value="Never"> {{ $t('common.routing.never') }} </option>
            <option value="Default" selected> {{ $t('common.routing.default') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="disable-expect-header">
            {{ $t('common.routing.disable_expect_header') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.disable_expect_header_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="DisableExpectHeader = !DisableExpectHeader" :checked="DisableExpectHeader" v-bind:value="DisableExpectHeader">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="enable-clock-skew-adjustement">
            {{ $t('common.routing.enable_clock_skew_adjustement') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.enable_clock_skew_adjustement_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="EnableClockSkewAdjustement = !EnableClockSkewAdjustement" :checked="EnableClockSkewAdjustement" v-bind:value="EnableClockSkewAdjustement">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="enable-host-prefix-infection">
            {{ $t('common.routing.enable_host_prefix_infection') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.enable_host_prefix_infection_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="enableHostPrefixInfection = !enableHostPrefixInfection" :checked="enableHostPrefixInfection" v-bind:value="enableHostPrefixInfection">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="enable-endpoint-discovery">
            {{ $t('common.routing.enable_endpoint_discovery') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.enable_endpoint_discovery_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="enableEndpointdiscovery = !enableEndpointdiscovery" :checked="enableEndpointdiscovery" v-bind:value="enableEndpointdiscovery">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
      </b-row>
    </form-accordion>

    <hr class="mx-auto" />
    <form-accordion :title="$t('common.routing.advanced_s3_option')" :isTitleUpperCase="false" :open="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="request-checksum-calculation">
            {{ $t('common.routing.request_checksum_calculation') }}
            <i  class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.request_checksum_calculation_info')"></i>
          </label>
          <select class="form-control" v-model="requestChecksumCalculation" :disabled="readonly" id="request-checksum-calculation">
            <option value="0" selected> {{ $t('common.routing.supported') }} </option>
            <option value="1"> {{ $t('common.routing.required') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="response-checksum-validation">
            {{ $t('common.routing.response_checksum_validation') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.response_checksum_validation_info')"></i>
          </label>
          <select class="form-control" v-model="responseChecksumValidation" :disabled="readonly" id="response-checksum-validation">
            <option value="0" selected> {{ $t('common.routing.supported') }} </option>
            <option value="1"> {{ $t('common.routing.required') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="use-virtual-addressing">
            {{ $t('common.routing.use_virtual_addressing') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.use_virtual_addressing_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="useVirtualAddressing = !useVirtualAddressing" :checked="useVirtualAddressing" v-bind:value="useVirtualAddressing">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="disable-multi-region-access-points">
            {{ $t('common.routing.disable_multi_region_access_points') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.disable_multi_region_access_points_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="disableMultiRegionAccessPoints = !disableMultiRegionAccessPoints" :checked="disableMultiRegionAccessPoints" v-bind:value="disableMultiRegionAccessPoints">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="use-arn-region">
            {{ $t('common.routing.use_arn_region') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.use_arn_region_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="useArnRegion = !useArnRegion" :checked="useArnRegion" v-bind:value="useArnRegion">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="payload-signing-policy">
            {{ $t('common.routing.payload_signing_policy') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.payload_signing_policy_info')"></i>
          </label>
          <select class="form-control" v-model="payloadSigningPolicy" :disabled="readonly" id="payload-signing-policy">
            <option value="0" selected> {{ $t('common.routing.request_dependent') }} </option>
            <option value="1"> {{ $t('common.routing.always') }} </option>
            <option value="2"> {{ $t('common.routing.never') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="disable-s3-express-auth">
            {{ $t('common.routing.disable_s3_express_auth') }}
            <i class="fa-duotone fa-circle-info cursor text-info tooltipIcon" :title="$t('common.routing.disable_s3_express_auth_info')"></i>
          </label>
          <div class="item-input" :disabled="readonly">
            <label class="label-switch">
              <input type="checkbox" class="checkService" @change="disableS3ExpressAuth = !disableS3ExpressAuth" :checked="disableS3ExpressAuth" v-bind:value="disableS3ExpressAuth">
              <div class="checkbox"></div>
            </label>
          </div>
        </b-col>
      </b-row>
    </form-accordion>

    <hr class="mx-auto" />
    <form-accordion :title="$t('common.routing.additional_option')" :isTitleUpperCase="false" :open="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group" v-if="inputValue.Role != 1">
          <form-write-group-label-input v-model="MinBufferSize" :disabled="inputValue.Role == 1 || readonly"
            :inputLabel="$t('common.routing.min_buffer_size')" :tooltipLabel="inputValue.Role == 1 ? undefined:$t('common.routing.min_buffer_output_size')" :placeholderValue="$t('common.routing.min_buffer_size')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" >
          <form-write-group-label-input v-model="MaxBufferSize" :disabled="readonly"
            :inputLabel="$t('common.routing.max_buffer_size')" :tooltipLabel="inputValue.Role == 1 ? $t('common.routing.max_buffer_size_input'):$t('common.routing.max_buffer_size_output')" :placeholderValue="$t('common.routing.max_buffer_size')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="inputValue.Role == 1">
          <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                                  :class="{'filter-item-input': true, 'filter-item-input-complete': BeginDate}"
                                  :inputLabel="$t('common.routing.begin_date')"
                                  customInputParentClass="filter-item-content"
                                  customInputClass="w-100"
                                  :maxLength="19"
                                  :tooltipLabel="inputValue.Role == 1 ? $t('common.routing.date_begin_input'):undefined"
                                  :placeholderValue="$t('common.datetime_picker_empty_date')"
                                  inputIcon="fa-solid fa-calendar"
                                  v-model="BeginDate" :disabled="inputValue.Role == 0 || readonly">
          </datetime-picker-custom>
        </b-col>
        <b-col sm="6" class="form-group" v-if="false" >
          <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                                  :class="{'filter-item-input': true, 'filter-item-input-complete': EndDate}"
                                  :inputLabel="$t('common.routing.end_date')"
                                  customInputParentClass="filter-item-content"
                                  customInputClass="w-100"
                                  :maxLength="19"
                                  :placeholderValue="$t('common.datetime_picker_empty_date')"
                                  inputIcon="fa-solid fa-calendar"
                                  v-model="EndDate" disabled>
          </datetime-picker-custom>
        </b-col>
      </b-row>
    </form-accordion>
    <b-row>
<!--      <b-col sm="6" class="form-group">-->
<!--        <label for="ssl-active">-->
<!--          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>-->
<!--        </label>-->
<!--        <select class="form-control" v-model="sslActive" :disabled="readonly" id="ssl-active">-->
<!--          <option value="1"> {{ $t('common.routing.yes') }} </option>-->
<!--          <option value="0" selected> {{ $t('common.routing.no') }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
<!--      <b-col v-if="sslActive != '0'" sm="6" class="form-group">-->
<!--        <label for="keystore">-->
<!--          {{ $t('common.routing.keystore') }}<span class="color-red"> * </span>-->
<!--        </label>-->
<!--        <select class="form-control" v-model="keystore" :disabled="readonly" id="keystore">-->
<!--          <option v-for="keystore in keystoreList" :key="keystore.id" :value="keystore.id"> {{ keystore.ConfigName }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
<!--      <b-col sm="6" v-if="sslActive != '0'" class="form-group">-->
<!--        <label for="ca">-->
<!--          {{ $t('common.routing.certificat') }}-->
<!--&lt;!&ndash;          <span class="color-red"> * </span>&ndash;&gt;-->
<!--        </label>-->
<!--        <select class="form-control" v-model="ca" :disabled="readonly" id="ca">-->
<!--          <option v-for="ca in caList" :key="ca.id" :value="ca.id"> {{ ca.ConfigName }} </option>-->
<!--        </select>-->
<!--      </b-col>-->
    </b-row>
<!--    <form-accordion :title="$t('common.token_credentials')" :isTitleUpperCase="false" v-if="login && password">-->
<!--      <b-row>-->
<!--        <b-col cols="6" class="fake-hr-right px-0">-->
<!--          <b-col class="form-group">-->
<!--            <form-write-group-label-input v-model="loginStorage" :disabled="true" :maxLength="512" inputType="select"-->
<!--              :inputLabel="$t('common.routing.loginStorage')">-->
<!--              <select class="form-control" v-model="loginStorage" :disabled="true">-->
<!--                <option value="">{{ $t('common.routing.volume_select') }}</option>-->
<!--                <option value="PEM">{{ 'PEM' }}</option>-->
<!--                <option value="FILE">{{ 'Volume' }}</option>-->
<!--                <option value="Vault">{{ 'Vault' }}</option>-->
<!--              </select>-->
<!--            </form-write-group-label-input>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="loginFile" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.loginFile')" :placeholderValue="$t('common.routing.loginFile')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="login-file-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="loginFileType" :disabled="true" id="login-file-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="loginYAML" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.loginYAML')" :placeholderValue="$t('common.routing.loginYAML')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="login-yaml-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="loginYAMLType" :disabled="true" id="login-yaml-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->

<!--        </b-col>-->
<!--        <b-col cols="6" class="px-0">-->
<!--          <b-col class="form-group">-->
<!--            <form-write-group-label-input v-model="passwordStorage" :disabled="true" :maxLength="512" inputType="select"-->
<!--              :inputLabel="$t('common.routing.passwordStorage')">-->
<!--              <select class="form-control" v-model="loginStorage" :disabled="true">-->
<!--                <option value="">{{ $t('common.routing.volume_select') }}...</option>-->
<!--                <option value="PEM">{{ 'PEM' }}</option>-->
<!--                <option value="FILE">{{ 'Volume' }}</option>-->
<!--                <option value="Vault">{{ 'Vault' }}</option>-->
<!--              </select>-->
<!--            </form-write-group-label-input>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="passwordFile" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.passwordFile')" :placeholderValue="$t('common.routing.passwordFile')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="pwd-file-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="passwordFileType" :disabled="true" id="pwd-file-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--          <b-col class="form-group">-->
<!--            <b-row>-->
<!--              <b-col cols="8">-->
<!--                <form-write-group-label-input v-model="passwordYAML" :disabled="true" :maxLength="512"-->
<!--                  :inputLabel="$t('common.routing.passwordYAML')" :placeholderValue="$t('common.routing.passwordYAML')">-->
<!--                </form-write-group-label-input>-->
<!--              </b-col>-->
<!--              <b-col cols="4">-->
<!--                <label for="pwd-yaml-type">{{ $t('common.variable') }}</label>-->
<!--                <b-form-radio-group v-model="passwordYAMLType" :disabled="true" id="pwd-yaml-type">-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="ENV">{{ $t('common.env') }}</b-form-radio>-->
<!--                  <b-form-radio ConfigName="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>-->
<!--                </b-form-radio-group>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
<!--        </b-col>-->
<!--      </b-row>-->
<!--    </form-accordion>-->
<!--    <level-control-form v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementWebService"></level-control-form>-->
    <!--<certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementWebService"></certificate-form-global>
    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementWebService"></private-keys-form-global>-->
  </div>
</template>
<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import {errorMessageAlert} from '@/helpers/alert'
import dateTimePicker from "@/components/common/dateTimePicker.vue"

export default {
  ConfigName: 'WebServiceConfigurationForm',
  components: {
    'datetime-picker-custom': dateTimePicker,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    msgType: {
    },
    entitiesType: {
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    isProxyPasswordFieldHidden () {
      return this.proxyPasswordType === 'password'
    },
    isSecretKeyPasswordFieldHidden () {
      return this.secretKeyPasswordType === 'password'
    },
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    SecretKey: {
      get () {
        return this.inputValue.SecretKey
      },
      set (val) {
        this.inputValue = {
          SecretKey: val.trim(),
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    AccessKey: {
      get () {
        return this.inputValue.AccessKey
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: val,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    ConfigName: {
      get () {
        return this.inputValue.ConfigName
      },
      set (val) {
        this.inputValue.useDualStack = (this.inputValue.useDualStack === '1') ? true : false
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: val,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    Prefix: {
      get () {
        return this.inputValue.Prefix
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: val,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    PrefixArchiving: {
      get () {
        return this.inputValue.PrefixArchiving
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: val,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    Region: {
      get () {
        return this.inputValue.Region
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: val,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    BucketName: {
      get () {
        return this.inputValue.BucketName
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: val,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    Port: {
      get () {
        return this.inputValue.Port
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: val,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    URI: {
      get () {
        return this.inputValue.URI
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: val,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    MinBufferSize: {
      get () {
        return this.inputValue.MinBufferSize
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: val,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    MaxBufferSize: {
      get () {
        return this.inputValue.MaxBufferSize
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: val,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    BeginDate: {
      get () {
        return this.inputValue.BeginDate
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: val,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    EndDate: {
      get () {
        return this.inputValue.EndDate
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: val,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    proxyActive: {
      get () {
        return this.inputValue.proxyActive
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: val,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    proxyScheme: {
      get () {
        return this.inputValue.proxyScheme
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: val,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    proxyPort: {
      get () {
        return this.inputValue.proxyPort
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: val,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    proxyLogin: {
      get () {
        return this.inputValue.proxyLogin
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: val,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    proxyPwd: {
      get () {
        return this.inputValue.proxyPwd
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: val.trim(),
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    proxyHost: {
      get () {
        return this.inputValue.proxyHost
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: val,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    ForceReOpen: {
      get () {
        return this.inputValue.ForceReOpen
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: val,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    Scheme: {
      get () {
        return this.inputValue.Scheme
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: val,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    useDualStack: {
      get () {
        return this.inputValue.useDualStack
      },
      set(val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: val,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    maxConnections: {
      get () {
        return this.inputValue.maxConnections
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: val,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    RequestTimeoutMs: {
      get () {
        return this.inputValue.RequestTimeoutMs
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: val,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    ConnectTimeoutMs: {
      get () {
        return this.inputValue.ConnectTimeoutMs
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: val,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    enableTcpKeepAlive: {
      get () {
        return this.inputValue.enableTcpKeepAlive
      },
      set(val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: val,
          enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    enableActive: {
      get () {
        return this.inputValue.enableActive
      },
      set(val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableActive,
          enableActive: val,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    tcpKeepAliveInvervalMs: {
      get () {
        return this.inputValue.tcpKeepAliveInvervalMs
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: val,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    lowSpeedLimit: {
      get () {
        return this.inputValue.lowSpeedLimit
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: val,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    VerifySSL: {
      get () {
        return this.inputValue.VerifySSL
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: val,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    FollowRedirects: {
      get () {
        return this.inputValue.FollowRedirects
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: val,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    DisableExpectHeader: {
      get () {
        return this.inputValue.DisableExpectHeader
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: val,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    EnableClockSkewAdjustement: {
      get () {
        return this.inputValue.EnableClockSkewAdjustement
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: val,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    enableHostPrefixInfection: {
      get () {
        return this.inputValue.enableHostPrefixInfection
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: val,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    enableEndpointdiscovery: {
      get () {
        return this.inputValue.enableEndpointdiscovery
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: val,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    caPath: {
      get () {
        return this.inputValue.caPath
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: val,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    caFile: {
      get () {
        return this.inputValue.caFile
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: val,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    requestChecksumCalculation: {
      get () {
        return this.inputValue.requestChecksumCalculation
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: val,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    responseChecksumValidation: {
      get () {
        return this.inputValue.responseChecksumValidation
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: val,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    useVirtualAddressing: {
      get () {
        return this.inputValue.useVirtualAddressing
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: val,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    disableMultiRegionAccessPoints: {
      get () {
        return this.inputValue.disableMultiRegionAccessPoints
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: val,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    useArnRegion: {
      get () {
        return this.inputValue.useArnRegion
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: val,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    payloadSigningPolicy: {
      get () {
        return this.inputValue.payloadSigningPolicy
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: val,
          disableS3ExpressAuth: this.inputValue.disableS3ExpressAuth
        }
      }
    },
    disableS3ExpressAuth: {
      get () {
        return this.inputValue.disableS3ExpressAuth
      },
      set (val) {
        this.inputValue = {
          SecretKey: this.inputValue.SecretKey,
          AccessKey: this.inputValue.AccessKey,
          ConfigName: this.inputValue.ConfigName,
          Prefix: this.inputValue.Prefix,
          PrefixArchiving: this.inputValue.PrefixArchiving,
          Region: this.inputValue.Region,
          BucketName: this.inputValue.BucketName,
          Port: this.inputValue.Port,
          URI: this.inputValue.URI,
          MinBufferSize: this.inputValue.MinBufferSize,
          MaxBufferSize: this.inputValue.MaxBufferSize,
          BeginDate: this.inputValue.BeginDate,
          EndDate: this.inputValue.EndDate,
          Role: this.inputValue.Role,
          proxyActive: this.inputValue.proxyActive,
          proxyScheme: this.inputValue.proxyScheme,
          proxyPort: this.inputValue.proxyPort,
          proxyLogin: this.inputValue.proxyLogin,
          proxyPwd: this.inputValue.proxyPwd,
          proxyHost: this.inputValue.proxyHost,
          ForceReOpen: this.inputValue.ForceReOpen,
          Scheme: this.inputValue.Scheme,
          useDualStack: this.inputValue.useDualStack,
          maxConnections: this.inputValue.maxConnections,
          RequestTimeoutMs: this.inputValue.RequestTimeoutMs,
          ConnectTimeoutMs: this.inputValue.ConnectTimeoutMs,
          enableTcpKeepAlive: this.inputValue.enableTcpKeepAlive,
          enableActive: this.inputValue.enableActive,
          tcpKeepAliveInvervalMs: this.inputValue.tcpKeepAliveInvervalMs,
          lowSpeedLimit: this.inputValue.lowSpeedLimit,
          VerifySSL: this.inputValue.VerifySSL,
          FollowRedirects: this.inputValue.FollowRedirects,
          DisableExpectHeader: this.inputValue.DisableExpectHeader,
          EnableClockSkewAdjustement: this.inputValue.EnableClockSkewAdjustement,
          enableHostPrefixInfection: this.inputValue.enableHostPrefixInfection,
          enableEndpointdiscovery: this.inputValue.enableEndpointdiscovery,
          caPath: this.inputValue.caPath,
          caFile: this.inputValue.caFile,
          requestChecksumCalculation: this.inputValue.requestChecksumCalculation,
          responseChecksumValidation: this.inputValue.responseChecksumValidation,
          useVirtualAddressing: this.inputValue.useVirtualAddressing,
          disableMultiRegionAccessPoints: this.inputValue.disableMultiRegionAccessPoints,
          useArnRegion: this.inputValue.useArnRegion,
          payloadSigningPolicy: this.inputValue.payloadSigningPolicy,
          disableS3ExpressAuth: val
        }
      }
    },
  },
  data () {
    return {
      keystoreList: [],
      caList: [],
      proxyPasswordType: 'password',
      secretKeyPasswordType: 'password'
    }
  },
  created () {
    if (this.mode === 'create') {
      if (this.prefilledURI !== undefined || this.prefilledURI === '') {
        this.inputValue.URI = this.prefilledURI
      }
      this.inputValue.sslActive = '0'
    }
  },
  methods: {
    switchProxyPasswordType () {
      if (this.proxyPasswordType === 'password') {
        this.proxyPasswordType = 'text'
      } else {
        this.proxyPasswordType = 'password'
      }
    },
    switchSecretKeyPasswordType () {
      if (this.secretKeyPasswordType === 'password') {
        this.secretKeyPasswordType = 'text'
      } else {
        this.secretKeyPasswordType = 'password'
      }
    }
  }
}

</script>
